export const IconListBullets: {
  name: 'icon_list_bullets-5f07c421ae43'
} = {
  name: 'icon_list_bullets-5f07c421ae43'
}
